module.exports = __webpack_public_path__ + "static/media/vegitables_17.4cbb4a73.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_17.csv
// module id = 599
// module chunks = 0